import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const ProductIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M12 11.7188L3 8.10938V17.3906L12 21V11.7188Z" fill={props.color} />
      <path d="M21 17.3906V8.10938L16.5 9.91406L12 11.7188V21L21 17.3906Z" fill={props.color} />
      <path
        d="M3 8.10938L12 11.7188M3 8.10938V17.3906L12 21M3 8.10938L7.5 6.30469L12 4.5L21 8.10938M12 11.7188L16.5 9.91406L21 8.10938M12 11.7188V21M21 8.10938V17.3906L12 21"
        stroke={props.color}
        strokeWidth="2"
      />
    </SvgCommon>
  );
};
